
























import Vue from 'vue';

import AppHeader from './components/AppHeader.vue';
import AppFooter from './components/AppFooter.vue';
import HomeHero from './components/HomeHero.vue';
import MyIntro from './components/MyIntro.vue';
import ProjectList from './components/ProjectList.vue';
import WorkStack from './components/WorkStack.vue';
import CommentsSection from './components/CommentsSection.vue';
import ProjectPage from './views/ProjectPage.vue';

import { db } from './api/db';

export default Vue.extend({
  name: 'app',
  components: {
    AppHeader,
    AppFooter,
    HomeHero,
    MyIntro,
    ProjectList,
    WorkStack,
    CommentsSection,
    ProjectPage,
  },
  data() {
    return {
      loading: false,
      firstLoad: true,
      ready: false,
      selectedProject: false,
      project: {},
      positionY: 0,

      fbHero: {},
      fbIntro: {},
      fbIcons: {},
      fbProjects: {},
      fbStack: {},
      fbComments: {},
    };
  },
  firebase: {
    fbHero: db.ref('/hero'),
    fbIntro: db.ref('/intro'),
    fbIcons: db.ref('/icons'),
    fbProjects: db.ref('/projects'),
    fbStack: db.ref('/stack'),
    fbComments: db.ref('/comments'),
  },
  // firestore: {
  //   fbHero: db.collection('/hero'),
  //   fbIntro: db.collection('/intro'),
  //   fbIcons: db.collection('/icons'),
  //   fbProjects: db.collection('/projects'),
  //   fbStack: db.collection('/stack'),
  //   fbComments: db.collection('/comments'),
  // },
  methods: {
    showProject(project) {
      this.selectedProject = true;
      this.project = project;
    },
    setPositionY(y) {
      this.positionY = y;
    },
    hideProject() {
      window.location.hash = '';
      this.selectedProject = false;
      this.project = {};
      window.scroll(0, this.positionY);
    },
    hashChangeCheck() {
      const newHash = window.location.hash;
      const newPath = newHash.slice(2);
      Object.keys(this.fbProjects).forEach((key) => {
        if (newPath === this.fbProjects[key].name) {
          this.showProject(this.fbProjects[key]);
        }
      });
    },
  },
  mounted() {
    setTimeout(() => {
      this.firstLoad = false;
      this.ready = true;
      this.hashChangeCheck();
      window.addEventListener('hashchange', this.hashChangeCheck, false);
    }, 2000);
  },
});
